
import { Component, Vue, Prop } from 'vue-property-decorator'
import Swiper, { SwiperOptions } from 'swiper'
import { PROP_ASSOCIATIONS_TITLE } from '../helpers/constants'
import { findPropWithId } from '../helpers/functions'

@Component({
  template: `
  <div>
    <h3 class="product-carousel-title">{{ relatedProducts.category }}</h3>
    <div class="product-carousel flex flex-justify-center">
      <div class="product-swiper">
        <swiper :options="ProductSwiperOptions" ref="productSwiper">
          <swiper-slide v-for='item in relatedProducts.value' :key='item.product?.sku'>
            <a class='category' :href='item.product?.url'>
              <img class='product__image' v-if='item.product?.primaryImage != null' :src='item.product?.primaryImage.url' />
            <div class='bottom flex flex-align-center flex-justify-center'>
              <div class='gray3--text text-center'>
                <div class="title">{{ getTitle(item) || item.name || item.product?.seoInfo.title }}</div>
                <div class="product-sku">{{ item.product?.sku }}</div>
              </div>
            </div>
            <i class="icons8-chevron-down-2 flex-align-center category__icon"></i>
            </a>
          </swiper-slide>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </div>
    </div>
  </div>
    `
})
export default class ProductCarousel extends Vue {
  productSwiper: Swiper | null = null
  @Prop() relatedProducts: any

  getTitle(item: any): string {
    return findPropWithId(item.product.properties, PROP_ASSOCIATIONS_TITLE, '')
  }

  ProductSwiperOptions: SwiperOptions = {
    spaceBetween: 20,
    slidesPerView: 1,
    watchOverflow: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    breakpoints: {
      768: {
        slidesPerView: 4
      }
    }
  }

  mounted() {
    this.$nextTick(() => {
      this.productSwiper = (this.$refs.productSwiper as any).$swiper as Swiper
    })
  }
}
